
global.$ = global.jQuery = require('jquery');

import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";


import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Headroom from "headroom.js";

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
window.Swiper = Swiper;


import Hls from "hls.js";
import "../../../../../plugins/lnk/digitalhub/assets/dist/digitalhub.js";

import AOS from 'aos';
import 'aos/dist/aos.css';


$(document).ready(function() {

    gsap.registerPlugin(CustomEase, SplitText, ScrollTrigger);
    function getDeviceType() {
        const userAgent = navigator.userAgent.toLowerCase();
        const isTouchDevice = navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
        const screenWidth = window.innerWidth;

        const isTablet = /ipad|android(?!.*mobile)|tablet|playbook|silk|kindle/i.test(userAgent) ||
            (screenWidth >= 600 && screenWidth <= 1280 && isTouchDevice);

        const isMobile = /iphone|ipod|android.*mobile|windows phone|blackberry/i.test(userAgent) ||
            (screenWidth < 600 && isTouchDevice);

        if (isTablet) {
            return "tablet";
        }

        if (isMobile) {
            return "mobile";
        }

        return "desktop";
    }

    const device = getDeviceType();

    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });

    if($('.headroom').length > 0){
        let headroomEl = document.querySelector("header");
        let options = {
            offset : 100,
        }
        let headroom  = new Headroom(headroomEl,options);
        headroom.init();
    }

    $(function() {
        AOS.init({
            duration: 600,
            //offset: 50,
            mirror: true,
            once: true,
        });
    });


    // const createTimeline = (selector, height) => gsap.timeline({
    //     paused: true,
    //     reversed: true
    // }).to(selector, {
    //     height: height,
    //     ease: CustomEase.create("custom", "M0,0 C0.126,0.382 0.32,0.628 0.478,0.776 0.67,0.956 0.818,1.001 1,1 "),
    //     duration: 0.3
    // });
    // const heightSearchSubmenu = device === "desktop" ? "60vh" : "100vh";
    // const menus = [{
    //     button: $('.link-prodotti'),
    //     submenu: $('#submenuProdotti'),
    //     timeline: createTimeline("#submenuProdotti.header_navbar", "50vh"),
    //     closeBtn: $('#closeSubmenuProdotti')
    // }, {
    //     button: $('.link-chisiamo'),
    //     submenu: $('#submenuAboutUs .position-aboutUs'),
    //     timeline: createTimeline("#submenuAboutUs.header_navbar", "245px"),
    //     closeBtn: $('#closeSubmenuAboutUs')
    // }, {
    //     button: $('.menuRight .link-search'),
    //     submenu: $('#submenuSearch'),
    //     timeline: createTimeline("#submenuSearch.header_navbar", heightSearchSubmenu),
    //     closeBtn: $('#closeSubmenuSearch')
    // }];
    //
    //
    // let body = $('body');
    //
    // const isHovered = el => el.length && el[0].matches(':hover');
    // const openMenu = menuItem => {
    //     menus.forEach(item => {
    //         item.submenu.removeClass('open');
    //         closeMenu(item);
    //     });
    //     if (!menuItem.submenu.hasClass('open')) {
    //         menuItem.submenu.addClass('open');
    //         if (menuItem.timeline) menuItem.timeline.play();
    //     }
    // };
    // const closeMenu = menuItem => {
    //     if (menuItem.timeline && menuItem.timeline.isAnimating) return;
    //     if (menuItem.submenu.hasClass('open')) {
    //         menuItem.submenu.removeClass('open');
    //         if (menuItem.timeline) menuItem.timeline.reverse();
    //         setTimeout(() => {
    //             $('#resultSearch').empty();
    //             $("#searchProdMenu").val("");
    //         }, 300);
    //
    //     }
    // };
    //
    // menus.forEach(menuItem => {
    //     const {
    //         button,
    //         submenu,
    //         timeline,
    //         closeBtn
    //     } = menuItem;
    //
    //     // GSAP animation callbacks
    //     if (timeline) {
    //         timeline.isAnimating = false;
    //         timeline.eventCallback("onStart", () => timeline.isAnimating = true);
    //         timeline.eventCallback("onComplete", () => timeline.isAnimating = false);
    //         timeline.eventCallback("onReverseComplete", () => timeline.isAnimating = false);
    //     }
    //     if (device === "desktop") { // hover behavior
    //         button.hover(() => {
    //             $(".header_navbar").removeClass("open");
    //             openMenu(menuItem);
    //         }, () => {
    //             if (!isHovered(submenu)) closeMenu(menuItem);
    //         });
    //         submenu.hover(() => {}, () => {
    //             if (!isHovered(button)) closeMenu(menuItem);
    //         });
    //     } else { // mobile click
    //         button.on('click', e => {
    //             e.preventDefault();
    //             submenu.hasClass('open') ? closeMenu(menuItem) : openMenu(menuItem);
    //         });
    //     }
    //     submenu.on('click', e => e.stopPropagation());
    //     closeBtn.on('click', e => {
    //         e.preventDefault();
    //         closeMenu(menuItem);
    //     });
    //
    //     if (button.hasClass('link-prodotti') || button.hasClass('link-chisiamo')) {
    //         button.on('click', e => {
    //             e.preventDefault();
    //         });
    //     }
    //
    // });
    //
    // body.on("click", () => {
    //     menus.forEach(closeMenu);
    // });


    const menusMobile = [
        {
            buttonClose: $('#burger_mobile'),
            menu: $('#submenuMainMobile')
        },
        {
            buttonClose: $("#submenuMainMobile #closeMobile"),
            menu: $("#submenuMainMobile")
        },
        {
            buttonClose: $("#submenuProdMobile #closeMobile"),
            menu: $("#submenuProdMobile"),
            showMenu: $("#submenuMainMobile .link-prodotti"),
            back: $("#submenuProdMobile #closeProdMobile"),
        },
        {
            buttonClose: $("#submenuAboutUsMobile #closeMobile"),
            menu: $("#submenuAboutUsMobile"),
            showMenu: $("#submenuMainMobile .link-chisiamo"),
            back: $("#submenuAboutUsMobile #closeAboutUsMobile")
        },
        {
            buttonClose: $("#submenuSearch #closeSubmenuSearch"),
            menu: $("#submenuSearch"),
            showMenu: $("#submenuMainMobile .link-search")
        }];

    let timelineMenu = gsap.timeline({
        paused: true,
        reversed: true
    }).from("#submenuMainMobile .menu-item", {
        opacity: 0,
        y: 30,
        duration: 1.2,
        stagger: 0.1,
        ease: 'expo.inOut'
    }, "-=0.7");


    menusMobile.forEach(menuItem => {
        const {
            buttonClose,
            menu,
            showMenu,
            back
        } = menuItem;

        if (buttonClose) {
            buttonClose.on('click', e => {
                e.preventDefault();
                if (menu.hasClass('open')) {
                    $(".header_mobile").removeClass("open");
                    menu.removeClass("open");
                    timelineMenu.reverse();
                } else {
                    menu.addClass("open");
                    timelineMenu.play(0);
                }
            });
        }

        if (showMenu) {
            showMenu.on('click', e => {
                e.preventDefault();
                menu.toggleClass("open");
            });
        }

        if (back) {
            back.on('click', e => {
                e.preventDefault();
                menu.toggleClass("open");
            });
        }
    });

    // $("#sitePickerMobile").on('click', function(e){
    //     e.preventDefault();
    //     e.stopPropagation();
    // });


    $("#sitePickerMobile, #sitePicker").hover(function(e){
        $(".sitePicker").addClass("show");
    },function(e){
        $(".sitePicker").removeClass("show");
    });


    let hideTimeout;

    $(".menu-item[data-category]").on("mouseenter", function () {
        clearTimeout(hideTimeout);

        const $category = $(this);
        const curCategory = $category.data("category");
        const $submenu = $(`.typo-submenu[data-products='${curCategory}']`);
        const $submenuContainer = $submenu.closest(".position-relative");

        // offset assoluti
        const categoryTop = $category.offset().top;
        const containerTop = $submenuContainer.offset().top;

        const relativeTop = (categoryTop - containerTop) + 16;

        $(".typo-submenu").hide();

        $submenu.css({
            top: relativeTop
        }).show();
    });

    $(".menu-item[data-category], .typo-submenu").on("mouseleave", function () {
        hideTimeout = setTimeout(() => {
            $(".typo-submenu").hide();
        }, 200);
    });

    $(".typo-submenu").on("mouseenter", function () {
        clearTimeout(hideTimeout);
    });




    /* RICERCA A MENU */
    // Request per la ricerca del prodotto
    /*let inputFilterProd = $("#searchProdMenu");
    inputFilterProd.keyup(function () {
        let valueInput = $(this).val();
        if(valueInput !== ""){
            if (valueInput.length >= 2){
                $.request("searchProduct::onSearchProduct", {
                    data: { data: valueInput },
                    complete: function() {

                    }
                });
            }else{
                $('#resultSearch').empty();
            }
        }
    });

    if ($(".header_mobile > .menu-item").length  > 0) {
        /!* animazioni menu mobile con GSAP *!/
        // gsap.set(".header_mobile .menu-item", { opacity: 0});
        let timeline_navItem = gsap.timeline({paused: true, reversed: true});
        timeline_navItem.fromTo(".header_mobile > .menu-item", {
            duration: 4,
            opacity: 0,
            ease: "power4.inOut",
        },{
            // duration: 4,
            opacity: 1,
            // ease: "power4.inOut",
        }, "-=1.4");
    }*/


    // change footer opener icon
    let mobileFooterOpener = $('#mobileFooterOpener')
    let footerInfos = $('#footerInfos')

    mobileFooterOpener.click(function (e) {
        e.preventDefault()
        if (mobileFooterOpener.hasClass('open')) {
            footerInfos.stop().slideUp(300);
            mobileFooterOpener.removeClass('open')
        } else {
            footerInfos.stop().slideDown(300);
            mobileFooterOpener.addClass('open')
            let n = $(document).height();
            // console.log(n)
            $('html, body').animate({scrollTop: n}, 200);
        }
    })



    /* Video homepage */
    let videoHome;
    let videoHomeSrc;

    if (device === "desktop") {
        videoHomeSrc = "themes/campesato/assets/images/home/video/video.m3u8";
        videoHome = document.getElementById("videoHome");
    } else {
        videoHomeSrc = "themes/campesato/assets/images/home/video/videoMobile.m3u8";
        videoHome = document.getElementById("videoHomeMobile");
    }

    if (videoHome) {
        // impostazioni obbligatorie iOS Safari
        videoHome.muted = true;
        videoHome.playsInline = true;
        videoHome.setAttribute("webkit-playsinline", "true");

        const tryPlay = () => {
            videoHome.play().then(() => {
                videoHome.style.opacity = 1;
            }).catch(() => {
                console.log("Autoplay bloccato da Safari, in attesa interazione utente");
            });
        };

        // HLS.js supportato?
        if (Hls.isSupported()) {
            const hls = new Hls();
            hls.loadSource(videoHomeSrc);
            hls.attachMedia(videoHome);
            hls.on(Hls.Events.MANIFEST_PARSED, tryPlay);
        }
        // Safari HLS nativo
        else if (videoHome.canPlayType("application/vnd.apple.mpegurl")) {
            videoHome.src = videoHomeSrc;
            videoHome.addEventListener("loadedmetadata", tryPlay);
        }

        // Fallback: sbloccare video alla prima interazione per vecchi iPadOS
        const unlockVideo = () => {
            tryPlay();
            document.removeEventListener("touchstart", unlockVideo);
            document.removeEventListener("click", unlockVideo);
        };
        document.addEventListener("touchstart", unlockVideo, { once: true });
        document.addEventListener("click", unlockVideo, { once: true });

    }


    /* SLIDE PAGINA MATERIALI */
    let curvaMaterial = "sine.inOut";
    let lastSlide, nextSlide;

    let swiperMaterial = new Swiper('.materialiSlider', {
        slidesPerView: 1,
        speed: 500,
        watchSlidesProgress: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true // evita sovrapposizioni fastidiose
        },
        navigation: {
            nextEl: '.swiper-button-next-material',
            prevEl: '.swiper-button-prev-material',
        },
        loop: true
    });

    swiperMaterial.on('slideChange', function(sld) {
        document.body.setAttribute('data-sld', sld.realIndex);
    })

    // // Aggiungo una classe per animare elementi interni (senza toccare l'HTML)
    // $('.materialiSlider .swiper-slide *').addClass('material-item');
    //
    // // Animazione al cambio slide
    // swiperMaterial.on("slideChangeTransitionStart", function () {
    //     lastSlide = $(this.slides[this.previousIndex]).find('.material-item');
    //     nextSlide = $(this.slides[this.activeIndex]).find('.material-item');
    //
    //     let timelineSwiperMaterial = gsap.timeline();
    //
    //     // blocchiamo animazioni in corso
    //     gsap.killTweensOf([lastSlide, nextSlide]);
    //
    //     // Slide attuale → esce a destra e sfuma
    //     timelineSwiperMaterial.to(lastSlide, {
    //         x: 50,
    //         opacity: 0,
    //         scale: 0.98,
    //         duration: 0.4,
    //         stagger: 0.04,
    //         ease: curvaMaterial
    //     });
    //
    //     // Nuova slide → parte da sinistra, entra e appare
    //     timelineSwiperMaterial.fromTo(nextSlide, {
    //         x: -50,
    //         opacity: 0,
    //         scale: 1.01
    //     }, {
    //         x: 0,
    //         opacity: 1,
    //         scale: 1,
    //         duration: 0.5,
    //         delay: 0.1, // sovrapposizione morbida
    //         stagger: 0.04,
    //         ease: curvaMaterial
    //     });
    // });
    //
    // // Resetto tutti gli elementi in caso di loop
    // swiperMaterial.on("slideResetTransitionEnd", function () {
    //     this.slides.forEach(slide => {
    //         gsap.set($(slide).find('.material-item'), { x: 0, opacity: 1, scale: 1 });
    //     });
    // });
    /* FINE SLIDE PAGINA MATERIALI */

    /* Animazione quadrati homepage */
    window.addEventListener("load", () => {

        const gallery = document.querySelector(".gallery");
        if (!gallery){
            return;
        }

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: gallery,
                start: "top 80%",
                end: "bottom 20%",
                scrub: true,
            }
        });

        tl.to(".row-1 .img-1", { flexBasis: "70%", ease: "power2.inOut" }, 0);
        tl.to(".row-1 .img-2", { flexBasis: "30%", ease: "power2.inOut" }, 0);

        tl.to(".row-2 .img-3", { flexBasis: "55%", ease: "power2.inOut" }, 0.2);
        tl.to(".row-2 .img-4", { flexBasis: "45%", ease: "power2.inOut" }, 0.2);
    });


    function addHeadingEffect(item) {
        if (item.length > 0) {
            item.addClass("heading-effect");
        }
    }

    function addContentEffect(item) {
        if (item.length > 0) {
            item.addClass("content");
        }
    }

    if ($('.active_content_editor').length > 0) {
        // addHeadingEffect($(".animation-tinyMCE:not(.mce-content-body) h1"));
        // addHeadingEffect($(".animation-tinyMCE:not(.mce-content-body) h2"));
        // addHeadingEffect($(".animation-tinyMCE:not(.mce-content-body) h3"));
        //
        // addContentEffect($(".animation-tinyMCE:not(.mce-content-body) h4"));
        // addContentEffect($(".animation-tinyMCE:not(.mce-content-body) h5"));
        // addContentEffect($(".animation-tinyMCE:not(.mce-content-body) h6"));
        // addContentEffect($(".animation-tinyMCE:not(.mce-content-body) div"));
        //
        // /* aggiungo alla descrizione della singola timeline l'effetto */
        // addContentEffect($(".section-single-time .content-effect p"));
        /* animazioni per titoli */
        const headingEffect = document.querySelectorAll(".heading-effect"); //classe per animare gli H1, H2..
        const content = document.querySelectorAll(".content"); //classe per animare il testo

        /* animazione per gli header */
        if (headingEffect.length > 0){

            headingEffect.forEach((target) => {
                target.style.opacity = 1;
                let words = new SplitText( target, { type: 'words'});

                gsap.from(words.words, {
                    autoAlpha: 0,
                    y: 50,
                    stagger: 0.035,
                    ease: "power2.out",
                    duration: 1.1,
                    visibility:"hidden",
                    scrollTrigger: {
                        trigger: target,
                        start: "top 100%",
                    }
                });
            });
        }

        /* animazione per il testo */
        if (content.length > 0){
            content.forEach((target) => {
                target.style.opacity = 1;
                let lines = new SplitText( target, { type: 'lines' });
                gsap.from(lines.lines, {
                    opacity: 0,
                    y: 50,
                    stagger: 0.05,
                    duration: 1,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: target,
                        start: "top 100%",
                    }
                });
            });
        }
    } else {
        /* avendo impostato l'opacità a zero via css per evitare il fouc, devo impostare opacity a 1 quando sto facendo dataentry */
        const headingEffect = document.querySelectorAll(".heading-effect"); //classe per animare gli H1, H2..
        const content = document.querySelectorAll(".content"); //classe per animare il testo

        /* animazione per gli header */
        if (headingEffect.length > 0) {

            headingEffect.forEach((target) => {
                target.style.opacity = 1;
            });
        }

        if (content.length > 0) {

            content.forEach((target) => {
                target.style.opacity = 1;
            });
        }
    }

    if ($("#accordionCertificazioni").length > 0){
        $('.accordion-collapse').on('shown.bs.collapse', function (e) {
            let $panel = $(this).closest('.accordion-item');
            $('html,body').animate({
                scrollTop: $panel.offset().top - 200
            }, 200);
        });
    }

    let linkProd = $(".link-prodotti");
    let linkColl = $(".link-chisiamo");

    let linkProdA = $(".link-prodotti a");
    let linkCollA = $(".link-chisiamo a");

    let contProdDesk = $("#submenuProdotti");
    let contCollDesk = $("#submenuAboutUs");

    openCloseSubMenu(linkProd, linkProdA, contProdDesk)
    openCloseSubMenu(linkColl, linkCollA, contCollDesk)

    function openCloseSubMenu(link, linka, sub) {
        link.click(function (e) {
            e.preventDefault();
        })

        link.hover(function (e) {
            sub.stop().slideDown(400);
            sub.addClass('open')
            e.stopPropagation()
        }, function (e) {
            sub.stop().slideUp(400);
            sub.removeClass('open')
            e.stopPropagation()
        });

        sub.hover(function (e) {
            sub.stop().slideDown(400);
            e.stopPropagation()
        }, function (e) {
            sub.stop().slideUp(400);
            e.stopPropagation()
        });
    }
});
